/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ session: NonNullable<unknown> }} Plan_Build_Day_Added_ToastInputs */

const en_us2_plan_build_day_added_toast = /** @type {(inputs: Plan_Build_Day_Added_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.session} created. Now pick its exercises`)
};

const pt_br2_plan_build_day_added_toast = /** @type {(inputs: Plan_Build_Day_Added_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.session} criado. Agora escolha os exercícios`)
};

const es_419_plan_build_day_added_toast = /** @type {(inputs: Plan_Build_Day_Added_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.session} creado. Ahora elige sus ejercicios`)
};

const pt_pt2_plan_build_day_added_toast = /** @type {(inputs: Plan_Build_Day_Added_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.session} criado. Agora escolhe os exercícios`)
};

const fr_fr2_plan_build_day_added_toast = /** @type {(inputs: Plan_Build_Day_Added_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.session} créée. Choisis maintenant ses exercices`)
};

const de_de2_plan_build_day_added_toast = /** @type {(inputs: Plan_Build_Day_Added_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.session} erstellt. Wähl jetzt die Übungen`)
};

const it_it2_plan_build_day_added_toast = /** @type {(inputs: Plan_Build_Day_Added_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.session} creato. Ora scegli gli esercizi`)
};

/**
* | output |
* | --- |
* | "{session} created. Now pick its exercises" |
*
* @param {Plan_Build_Day_Added_ToastInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_build_day_added_toast = /** @type {((inputs: Plan_Build_Day_Added_ToastInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Build_Day_Added_ToastInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_build_day_added_toast(inputs)
	if (locale === "es-419") return es_419_plan_build_day_added_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_build_day_added_toast(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_build_day_added_toast(inputs)
	if (locale === "de-DE") return de_de2_plan_build_day_added_toast(inputs)
	if (locale === "it-IT") return it_it2_plan_build_day_added_toast(inputs)
	return en_us2_plan_build_day_added_toast(inputs)
});
export { plan_build_day_added_toast as "plan-build.day_added_toast" }